export var ActivityStatus;
(function (ActivityStatus) {
    ActivityStatus["FAILED"] = "FAILED";
    ActivityStatus["LOADING"] = "LOADING";
    ActivityStatus["ENDED"] = "ENDED";
    // R004：活动已结束
    ActivityStatus["UNJOINED"] = "UNJOINED";
    ActivityStatus["PRE_JOINED"] = "PRE_JOINED";
    // R001：已预选城市但未锁定
    ActivityStatus["HAVE_FREE_CARD_UNUSED"] = "HAVE_FREE_CARD_UNUSED";
    // 原 HAVE_FREE_CARD 拆分（R003）
    ActivityStatus["HAVE_FREE_CARD_USED"] = "HAVE_FREE_CARD_USED";
    // 原 HAVE_FREE_CARD 拆分（R003）
    ActivityStatus["ON_PROGRESS"] = "ON_PROGRESS";
})(ActivityStatus || (ActivityStatus = {}));
export var RecordTabType;
(function (RecordTabType) {
    RecordTabType["REWARD"] = "REWARD";
    RecordTabType["ASSIST"] = "ASSIST";
})(RecordTabType || (RecordTabType = {}));
export var ExplorePhase;
(function (ExplorePhase) {
    ExplorePhase["PRE_BOOK"] = "PRE_BOOK";
    ExplorePhase["SAME_DAY"] = "SAME_DAY";
})(ExplorePhase || (ExplorePhase = {}));
export const ACTIVITY_OFFLINE_CODE = 10003;
export const ACTIVITY_BLOKCED_CODE = 14001;
export const NOT_VALID_FOR_ACTIVITY = 12001;
export const ACTIVITY_ENDED_CODE = 10005; // R004：活动已结束状态码
export const INVALID_CODES = [ACTIVITY_OFFLINE_CODE, ACTIVITY_BLOKCED_CODE, NOT_VALID_FOR_ACTIVITY];
export const USER_INFO_VALID_CODE = 401;
export const USER_INFO_VALID_MSG = '登录信息错误';
// R004：预约接口 marketingIdType 固定值
export const MARKETING_ID_TYPE = 1;
// R004：预约缓存 key
export const IS_SUBSCRIBED_CACHE_KEY = 'isSubscribedNextActivity';
export var API_PATH;
(function (API_PATH) {
    API_PATH["QUERY_INFO"] = "/api/altas/marketing/activity/query/info";
    API_PATH["RECOMMEND_CITIES"] = "/api/altas/marketing/recommend/cities";
    API_PATH["JOIN_ACTIVITY"] = "/api/altas/marketing/activity/join/activity";
    API_PATH["TASK_COMPLETE"] = "/api/altas/marketing/task/complete";
    /** 奖励记录查询 */
    API_PATH["REWARDS"] = "/api/altas/marketing/query/user/reward";
    /** 打Call记录查询 */
    API_PATH["ASSIST_RECORD"] = "/api/altas/marketing/query/assist/record";
    /** 免单卡获奖公告查询 */
    API_PATH["FREE_ORDER_CARD_LEADERBOARD"] = "/api/altas/marketing/query/freeOrderCard/leaderboard";
    /** 通用弹窗频控查询 */
    API_PATH["QUERY_POPUP_CACHE"] = "/api/altas/marketing/query/popup/cache";
    /** 3.14：活动缓存读写 */
    API_PATH["ACTIVITY_CACHE"] = "/api/altas/marketing/activity/cache/set";
    /** 3.15：查询预约状态 */
    API_PATH["QUERY_APPOINTMENT"] = "/api/altas/marketing/user/query/appointment";
    /** 3.16：写入预约 */
    API_PATH["SET_APPOINTMENT"] = "/api/altas/marketing/user/appointment";
    /** 3.9：集卡分组详情查询 */
    API_PATH["CARD_GROUP_DETAIL"] = "/api/altas/marketing/query/cardGroup/detail";
    /** R007 3.18：千人千面推荐供给（酒店/民宿浏览任务取 poiId） */
    API_PATH["PERSONALIZATION_REC"] = "/landing/page/personalization/rec";
})(API_PATH || (API_PATH = {}));
export var InviteType;
(function (InviteType) {
    InviteType[InviteType["INVITE_ASSIST"] = 1] = "INVITE_ASSIST";
})(InviteType || (InviteType = {}));
export var ClickFreeCardUseBtnTriggerFlowType;
(function (ClickFreeCardUseBtnTriggerFlowType) {
    ClickFreeCardUseBtnTriggerFlowType["OPEN_BOTTOM_MODAL"] = "openBottomModal";
    ClickFreeCardUseBtnTriggerFlowType["JUMP_TO_ANCHOR"] = "jumpToAnchor";
})(ClickFreeCardUseBtnTriggerFlowType || (ClickFreeCardUseBtnTriggerFlowType = {}));
// R001/R004：缓存操作类型
export var CacheOperation;
(function (CacheOperation) {
    CacheOperation[CacheOperation["Read"] = 0] = "Read";
    CacheOperation[CacheOperation["WriteIfAbsent"] = 1] = "WriteIfAbsent";
    CacheOperation[CacheOperation["WriteOverride"] = 2] = "WriteOverride";
})(CacheOperation || (CacheOperation = {}));
// R001：缓存 key 枚举
export var CacheKey;
(function (CacheKey) {
    CacheKey["PreSelectedCity"] = "PRE_SELECTED_CITY";
    /** R007：浏览任务完成状态聚合缓存。value 为 { [taskId]: { clickTime, completed } } 的 JSON */
    CacheKey["BrowseTask"] = "BROWSE_TASK";
})(CacheKey || (CacheKey = {}));
/* ============================================================
 * R007：任务半页弹窗（浏览/下单任务）
 * ============================================================ */
/** R007：任务按钮展示态（一一映射后端 TaskStatus） */
export var TaskButtonState;
(function (TaskButtonState) {
    TaskButtonState["UNFINISHED"] = "unfinished";
    // 未完成
    TaskButtonState["FINISHED"] = "finished";
    // 已完成
    TaskButtonState["IMPOSSIBLE"] = "impossible"; // 不可完成
})(TaskButtonState || (TaskButtonState = {}));
/** R007：任务完成接口（3.8）业务状态码 */
export var TaskCompleteStatus;
(function (TaskCompleteStatus) {
    TaskCompleteStatus[TaskCompleteStatus["SUCCESS"] = 0] = "SUCCESS";
    TaskCompleteStatus[TaskCompleteStatus["USER_RISK"] = 405] = "USER_RISK";
    // 风控未通过
    TaskCompleteStatus[TaskCompleteStatus["OTHER_ERROR"] = 500] = "OTHER_ERROR";
    TaskCompleteStatus[TaskCompleteStatus["PARAM_ERROR"] = 501] = "PARAM_ERROR";
})(TaskCompleteStatus || (TaskCompleteStatus = {}));
/** R007：任务完成接口 cannotCode */
export var TaskCompleteCannotCode;
(function (TaskCompleteCannotCode) {
    TaskCompleteCannotCode[TaskCompleteCannotCode["SAME_USER_ID_NOT_ALLOWED"] = 10079] = "SAME_USER_ID_NOT_ALLOWED"; // 主态和客态用户 ID 不能相同
})(TaskCompleteCannotCode || (TaskCompleteCannotCode = {}));
/** R007：完成接口响应解析结果类别 */
export var CompleteResultKind;
(function (CompleteResultKind) {
    CompleteResultKind["OK"] = "OK";
    CompleteResultKind["RISK"] = "RISK";
    CompleteResultKind["SAME_USER"] = "SAME_USER";
    CompleteResultKind["ERROR"] = "ERROR";
})(CompleteResultKind || (CompleteResultKind = {}));
